<template>
  <div class="kk-designer__no-object-text" @dragover="dragOver" @drop="drop">
    <i18n-t keypath="processDesigner.noObject.text" tag="p" scope="global">
      <template #addObject>
        <b>{{ $t("processDesigner.noObject.addObject") }}</b>
      </template>
    </i18n-t>
  </div>
</template>

<script>
import DesignerMixin from "./DesignerMixin";
import { ProcessTypes } from "../../utils/icons";

export default {
  mixins: [DesignerMixin],
  computed: {
    dropIndicator() {
      return this.$store.state.cells.dropIndicator;
    },
  },
  methods: {
    dragOver(e) {
      if (e.dataTransfer.types.includes("player") && this.current.type !== ProcessTypes.Grid) {
        e.preventDefault();
        if (this.visiblePlayers.length > 0) return this.setIndicator(e);

        this.$store.dispatch("cells/setdropIndicator", {
          id: this.columns[this.columns.length - 1].id,
        });
      }
    },
    async drop(e) {
      if (!e.dataTransfer.getData("player")) return;
      const dropIndicator = { ...this.dropIndicator };

      const id = e.dataTransfer.getData("id");
      if (!dropIndicator.id) return;

      const column = this.columnMap[dropIndicator.id];
      const index = column.index;

      const newIndexOffset = this.current.type === ProcessTypes.Posting ? 2 : 1;
      const newCellIndex = index + newIndexOffset;

      // Add new cell before or after this cell
      const action = this.current.type === ProcessTypes.Posting ? "addPostingPlayer" : "addPlayer";
      this.$store.dispatch(`cells/${action}`, { ids: [id], index: newCellIndex });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-designer__no-object-text {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed @kk-color-dark;
  border-radius: 0.75rem;
  margin: 2.15rem;
  padding: 1rem;
  color: @kk-color-dark;
  font-family: "Ubuntu", sans-serif;
  align-items: center;
  text-align: center;
  font-size: 1.6rem;
}
</style>
